import type { ButtonGroupProps } from 'react-multi-carousel';

import Image from '@/app/components/Image';
import SlideshowThumbnail from '@/app/components/Slideshow/SlideshowThumbnail';

import type { ProductImage } from './types';

interface FsaSlideShowNavProps extends ButtonGroupProps {
  readonly images: ProductImage[];
  readonly onChange: (idx: number) => void;
}

interface CurrentTarget {
  currentTarget: {
    value: string;
  };
}

const FsaSlideshowNavigation = ({
  carouselState,
  images,
  goToSlide,
  onChange,
}: FsaSlideShowNavProps) => {
  const currentSlideIndex = carouselState?.currentSlide;

  const handleChange = ({ currentTarget }: CurrentTarget) => {
    const nextSlideIndex = Number(currentTarget.value);
    onChange(nextSlideIndex);
    goToSlide?.(nextSlideIndex);
  };

  return (
    <div className="mx-auto my-0 mt-6 flex max-w-sm flex-1 justify-center gap-2">
      {images.map(({ localizedAlt, localizedSrc, src }, idx: number) => (
        <SlideshowThumbnail
          data-cy={`pdp-slideshow-thumbnail-${idx}`}
          data-selected={currentSlideIndex === idx}
          key={`pdp-slideshow-thumbnail-${localizedAlt}`}
          index={idx}
          isSelected={currentSlideIndex === idx}
          onClick={handleChange}
          image={
            <Image
              className="aspect-4/3 size-full"
              height={72}
              localizedAlt={localizedAlt}
              localizedSrc={localizedSrc}
              src={src}
              width={72}
            />
          }
        />
      ))}
    </div>
  );
};

export default FsaSlideshowNavigation;
